
import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilterFormAttributeByKey, getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import $ from "jquery";
import datepicker from 'bootstrap-datepicker'
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper";

export class LayerInfoFilterSettingsDateComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const label = this.getAttribute('data-label')
        const formAttribute = getActiveFilterFormAttributeByKey(key)

        const template = document.createElement('template');

        if(label === 'Tussen') {
             template.innerHTML = `
            <div class="row">
                <div class="col-2"><div class="form-group mt-2">Vanaf</div></div>
                <div class="col-4"><input type="text" class="form-control"></div>
                <div class="col-2"><div class="form-group mt-2">Tot</div></div>
                <div class="col-4"><input type="text" class="form-control"></div>
            </div>`;
        } else {
             template.innerHTML = `
            <div class="row">
                <div class="col-2"><div class="form-group mt-2">` + label + `</div></div>
                <div class="col-10"><input type="text" class="form-control"></div>
            </div>`;
        }

        initWebComponent(this, template)

        $.fn.datepicker.dates['nl'] = {
            days:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],
            daysShort:["zo","ma","di","wo","do","vr","za"],
            daysMin:["zo","ma","di","wo","do","vr","za"],
            months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],
            monthsShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],
            today:"Vandaag",
            monthsTitle:"Maanden",
            clear:"Wissen",
            weekStart:1,
            format:"dd-mm-yyyy"
        };
        let parent = this
        this.querySelectorAll('input').forEach(element => {
            $(element).datepicker({
                format: 'dd-mm-yyyy',
                weekStart: 1,
                language: 'nl',
                orientation: 'bottom',
                autoclose: true,
                clearBtn: true,
            }).on('changeDate', function(e) {
                $(this).datepicker('hide');

                let values = []
                parent.querySelectorAll('input').forEach( element => {
                    if(element.value !== "") {
                        values.push(element.value)
                    }
                })
                let value = values.join(' - ')
                if(value.length > 0) {
                    value = label + ': ' + value
                }
                updateFilterBadge(this, value)
            });
        })
    }
}
